module.exports = __webpack_public_path__ + "static/media/video-guide.e8b8683b.mp4";